import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface INoResultsFallbackProps {
  text?: string;
}

function NoResultsFallback({ text }: INoResultsFallbackProps) {
  return (
    <>
      <FontAwesomeIcon
        icon={faMagnifyingGlass}
        fontSize={96}
        className="flex mx-auto mt-32 text-subtitle"
      />
      <h3 className="mt-8 text-2xl text-center text-subtitle">
        {text ?? 'No results found'}
      </h3>
    </>
  );
}

export default NoResultsFallback;
